<script>
export default {}
</script>

<template>
  <div>
    <b-card-group deck>
      <b-card class="text-center" header="Customize Page here...">
        <slot />
        <!-- <b-form v-if="prequalSecondForm"> second form</b-form> -->
      </b-card>
    </b-card-group>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
